export default __webpack_public_path__ + "static/media/jalaponia_thumb.c97e8977.jpg";